// Seconds before expiry at which we proactively refresh the access token.
// The backend issues 15-minute JWTs; refreshing 60 s early avoids races where
// a token expires between the check and the actual HTTP round-trip.
export const REFRESH_BUFFER_SECONDS = 60;

// Decode the exp claim from a JWT without verifying the signature.
// Returns true when the token is already expired or will expire within
// REFRESH_BUFFER_SECONDS. Returns false for null/undefined/malformed tokens
// so the caller falls through to the existing reactive-401 retry path.
export function isTokenExpiredOrExpiringSoon(token) {
  if (!token) return false;
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return false;
    // atob is available in every browser and in jsdom (used by Jest).
    const payload = JSON.parse(atob(parts[1]));
    if (typeof payload.exp !== 'number') return false;
    const nowSeconds = Math.floor(Date.now() / 1000);
    return payload.exp <= nowSeconds + REFRESH_BUFFER_SECONDS;
  } catch {
    return false;
  }
}
